import { render } from "./AddressEditComponent.vue?vue&type=template&id=de356e14"
import script from "./AddressEditComponent.vue?vue&type=script&lang=js"
export * from "./AddressEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__